import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
    userId: null,
    absoluteUrl: '',
    fullName: '',
    thumbnailUrl: '',
    thumbnailBackground: '',
    permissions: [],
    adminForGateways: [],
    messageCount: 0,
    numDatasets: 0,
    numMaps: 0,
    numGalleries: 0,
    numArticles: 0,
    numGroups: 0,
    numGroupsMemberOf: 0,
    numBookmarks: 0
});

/* actions */
export const actionTypes = {
    UPDATE_USER_INFO: 'UPDATE_USER_INFO'
};

const updateUserInfo = userInfo => ({
    type: actionTypes.UPDATE_USER_INFO,
    userInfo
});

export const actions = {
    updateUserInfo
};

/* reducer */
export const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_USER_INFO:
            return state.merge(fromJS(action.userInfo));
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./source/modules/people.js